export default (type, event, body) => {
  const track = window?.gtag || undefined;
  if (track) {
    track(type, event, body);
  }
};
